import QuestionService from '@/bundles/Questions/services/QuestionService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function questionServiceFactory() {
  return new QuestionService(
    http,
    new ErrorMapper(),
  );
}

export const questionsService = questionServiceFactory();
